<template>
  <b-overlay
    :show="busy"
    rounded
    opacity="0.6"
    spinner-small
    spinner-variant="secondary"
    class="d-inline-block"
    v-bind="$attrs"
  >
    <b-button
      v-bind="$attrs"
      @click="() => showBillImgDetail()"
      variant="secondary"
      style="padding: 1px 12px;"
    >
      Baixar
    </b-button>
  </b-overlay>
</template>

<script>
import { Api } from '../../../vue/api';
const API = new Api();

export default {
  props: {
    consumerBillUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    async showBillImgDetail() {
      this.busy = true;
      const result = await API.post('/execute', {
        path: `/get-consumer-bill-photo/${encodeURIComponent(
          btoa(this.consumerBillUrl),
        )}`,
        method: 'get',
      });

      const virgulaPosition = result.model.indexOf(',');
      const base64Image = result.model.substring(virgulaPosition + 1);
      const byteCharacters = atob(base64Image);

      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'image/jpeg' });

      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
      this.busy = false;
    },
  },
};
</script>
